import { Component, OnInit } from '@angular/core';
import { IResidues } from 'src/app/interfaces';
import { ResiduesService } from 'src/app/services/residues.service';
import { UsersService } from 'src/app/services/users.service';
import * as M from '../../../../../styles/materialize/js/materialize.min.js';
@Component({
  selector: 'app-painel-pessoa-juridica',
  templateUrl: './painel-pessoa-juridica.component.html',
  styleUrls: ['./painel-pessoa-juridica.component.css']
})
export class PainelPessoaJuridicaComponent implements OnInit {
  constructor(private usersService: UsersService, private residuesService: ResiduesService) {}

  options = {};
  residues: IResidues[] = [];
  imageUrl: string = "";

  ngOnInit(): void {
    const elements = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elements, this.options);

    this.residuesService.getResidues().subscribe((residues) => {
      residues.map(residue => {
          this.residuesService.getResidueImage(residue.data.imagePath).subscribe((image: any) =>  {
            residue.data.imagePath = `url(${image.signedURL})`;
          })
          this.residues = residues;
      })
    })
  }

  logout(){
    this.usersService.logout();
  }
}
